import React, { Fragment, useLayoutEffect, useRef, useState } from "react"

import clsx from "clsx"

import { getLayout } from "services"
import KcWelcomeLayerPrompt from "./KcWelcomeLayerPrompt"
import KioskLandingRenderer from "./KioskLandingRenderer"
import classes from "./KcWelcomeLayer.module.scss"

const time = 1000 * 60 * 3

const KcWelcomeLayer = () => {
  const [showLayer, setShowLayer] = useState(true)
  const [openPromptModal, setOpenPromptModal] = useState(false)
  const [landingLayout, setLandingLayout] = useState(null)
  const [landingLoaded, setLandingLoaded] = useState(false)

  const timeout = useRef()
  const hasDismissedInitialLayer = useRef(false)

  const getLandingLayout = async () => {
    try {
      const layout = await getLayout()
      const currentLanding = layout.landing || {}

      if (
        currentLanding.isPublished &&
        Array.isArray(currentLanding.components) &&
        currentLanding.components.length > 0
      ) {
        setLandingLayout(currentLanding)
        return
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLandingLoaded(true)
    }
  }

  const handleClick = () => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(() => {
        setShowLayer(true)
      }, time)
  }

  const handleHideLayer = event => {
    if (!showLayer) return

    event.preventDefault()
    event.stopPropagation()

    hasDismissedInitialLayer.current = true

    setOpenPromptModal(false)

    setShowLayer(false)
  }

  useLayoutEffect(() => {
    getLandingLayout()

    window.addEventListener("mousedown", handleClick)

    window.addEventListener("touchstart", handleClick)

    return () => {
      clearTimeout(timeout.current)

      window.removeEventListener("mousedown", handleClick)

      window.removeEventListener("touchstart", handleClick)
    }
  }, [])

  return (
    <Fragment>
      {
        landingLoaded &&
        !!landingLayout &&
        <div
          onPointerDownCapture={event => {
            event.preventDefault()
            event.stopPropagation()
          }}
          onClick={handleHideLayer}
          className={clsx(
            classes["container"],
            showLayer && classes["show"]
          )}
        >
          <KioskLandingRenderer landingLayout={landingLayout} />
        </div>
      }

      <KcWelcomeLayerPrompt
        setShowLayer={setShowLayer}
        openPromptModal={openPromptModal}
        setOpenPromptModal={setOpenPromptModal}
      />
    </Fragment>
  )
}

export default KcWelcomeLayer
